<template>
  <BaseTabItemSecondary
    :is-selected="isActive"
    :title="title"
    :color="color"
    :description="description"
    :rounded="rounded"
    @click="activeTab"
  >
    <slot />
  </BaseTabItemSecondary>
</template>

<script>
import { computed, getCurrentInstance, inject, watchEffect } from 'vue';

import BaseTabItemSecondary from '@/components/ui/BaseTabItemSecondary.vue';

export default {
	name: 'Tab',
	components: { BaseTabItemSecondary },
	props: {
		title: String,
		value: {
			type: String,
			required: false,
		},
		color: {
			type: String,
			required: false,
		},
		description: {
			type: String,
			required: false,
		},
		rounded: {
			type: Boolean,
			default: true,
		},
	},
	setup (props) {
		const instance = getCurrentInstance();

		const { tabs, selectTab, active } = inject('tabsState', {
			tabs: [],
			selectTab: () => {
			},
		});

		const index = computed(() => tabs.value.findIndex(target => target.uid === instance.uid));

		const isActive = computed(() => {
			const value = props?.value;

			if (value) {
				return tabs.value[index.value]?.props?.value === active.value;
			}

			return index.value === active.value;
		});

		const activeTab = () => {
			const value = props?.value;

			selectTab(value ? tabs.value[index.value]?.props?.value : index.value);
		};

		watchEffect(() => {
			if (index.value === -1) {
				tabs.value.push(instance);
			}
		});

		return {
			activeTab,
			isActive,
		};
	},
};
</script>
